import React, { Component } from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import moment from 'moment';
import { injectIntl, intlShape } from 'react-intl';

import DatePicker from './date-picker';
import {
    CUSTOM_DATE,
    LAST_WEEK,
    THIS_SCHOOL_YEAR,
    THIS_WEEK
} from './date-picker-constants';
import messages from './messages';

import { getLocale } from './../../i18n';
import css from './index.scss';

class DatePickerComp extends Component { // eslint-disable-line react/prefer-stateless-function
    render() {
        const { disabled, intl } = this.props;
        const datePickerLabels = {
            [CUSTOM_DATE]: intl.formatMessage(messages.customDate),
            [LAST_WEEK]: intl.formatMessage(messages.lastWeek),
            [THIS_SCHOOL_YEAR]: intl.formatMessage(messages.thisSchoolYear),
            [THIS_WEEK]: intl.formatMessage(messages.thisWeek)
        };
        const disabledFlag = disabled ? 'disabled-datepicker' : '';
        moment.locale(getLocale().substr(0, 2));
        return <DatePicker {...this.props} className={`${css.datepicker} ${disabledFlag}`} labels={datePickerLabels} />;
    }
}

DatePickerComp.propTypes = {
    disabled: PropTypes.bool,
    intl: intlShape.isRequired
};

export default injectIntl(styleable(css)(DatePickerComp));




// WEBPACK FOOTER //
// ./app/components/date-picker/index.js